
import Vue from 'vue'
import objectDiff from 'objectdiff'
import {
  isDOM,
  isDynamicApiString,
  isDynamicVariableString,
  isObject,
  isString,
} from '../utils/validator'
import {
  create,
  get,
} from './dom'

const axios = require('@/assets/lib/axios')

export function getDynamicApi (url, method) {
  url = url.slice(4)

  return function (...args) {
    return method(url, ...args)
  }
}

export function set (obj = {}, key = '', value) {
  if (isReactive(obj, key)) {
    obj[key] = value
  } else {
    delete obj[key]
    Vue.set(obj, key, value)
  }

  return obj
}

export function getDynamicVariableKey (key) {
  return key.slice(2)
}

function getDynamicVariableValue (val = '', data = {}) {
  return data[getDynamicVariableKey(val)]
}

export function normalizeDynamicDataByMobile (obj = {}, data = {}, method) {
  obj = obj || {}

  for (const key in obj) {
    if (obj.hasOwnProperty && obj.hasOwnProperty(key)) {
      const item = obj[key]

      if (isDynamicVariableString(item)) {
        obj[key] = getDynamicVariableValue(item, data)
      } else if (isDynamicApiString(item)) {
        obj[key] = getDynamicApi(item, method)
      } else if (isObject(item) || Array.isArray(item)) {
        obj[key] = normalizeDynamicDataByMobile(item, data, method)
      }
    }
  }

  return obj
}

export class Cancel {
  token = null

  cancel = null

  constructor () {
    const source = axios.CancelToken.source()
    this.token = source.token
    this.cancel = source::source.cancel
  }
}

export function throttle (fn, delay = 100) {
  let timer
  let lastArg

  return (...args) => {
    lastArg = args

    if (!timer) {
      timer = setTimeout(() => {
        fn.apply(this, lastArg || args)
        timer = null
      }, delay)
    }
  }
}

export function debounce (fn, delay = 100) {
  let timer

  return (...args) => {
    if (timer) {
      clearTimeout(timer)
    }

    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

export function sleep (ms = 0) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export function isReactive (obj = {}, key = '') {
  const descriptors = Object.getOwnPropertyDescriptors(obj)

  return !!descriptors[key]?.get
}

export function placeholder (obj = {}, placeholder = '') {
  return String(placeholder).replace(/{[a-zA-Z]+}/g, (key) => obj[key.replace(/[{}]/g, '')] ?? '')
}

export function fireEvent (event = '') {
  let withoutOn = ''
  let withOn = ''

  if (event.startsWith('on')) {
    withOn = event
    withoutOn = event.replace(/^on/, '')
  } else {
    withOn = `on${event}`
    withoutOn = event
  }

  if (document.createEvent) {
    const e = document.createEvent('HTMLEvents')

    e.initEvent(withoutOn, true, true)
    window.dispatchEvent(e)
  } else if (document.createEventObject) {
    window.fireEvent(withOn)
  }
}

let $size

export function getStringWidth (str = '', target) {
  if (!str) {
    return 0
  }

  if (!$size) {
    $size = create('span')

    // 容器样式
    $size.classList.add('fixed', 'pin-l', 'pin-t')
    $size.style.zIndex = -1000
    $size.style.opacity = 0

    document.body.appendChild($size)
  }

  /**
   * 获取字符串样式
   */
  let style

  if (isObject(target)) {
    style = target
  } else {
    let $target = target

    if (isString($target)) {
      $target = get($target)
    }

    if (isDOM($target)) {
      style = getComputedStyle($target)
    }
  }

  /**
   * 如果有样式, 就设置一下所有可能影响到字符串宽度的样式。
   * 如果没有就删除样式，继承默认样式
   */
  if (style) {
    $size.style.fontSize = style.fontSize
    $size.style.fontFamily = style.fontFamily
    $size.style.fontWeight = style.fontWeight
  } else {
    delete $size.style.fontSize
    delete $size.style.fontFamily
    delete $size.style.fontWeight
  }

  $size.innerText = str

  return $size.offsetWidth
}

export function hash (str = '', maxLength = 20) {
  let hash = 5381
  let i = str.length

  while (i) hash = (hash * 33) ^ str.charCodeAt(i -= 1)
  hash >>>= 0

  return hash.toString(36).substr(0, maxLength)
}

export function def (obj, key, value, enumerable = true) {
  Object.defineProperty(obj, key, {
    value,
    enumerable: !!enumerable,
    writable: true,
    configurable: true,
  })

  return obj
}

export function hasOwn (obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key)
}

export function repeat (value, count) {
  return new Array(count).fill(value)
    .join('')
}

export function randomString (length) {
  length = length || 32
  const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = $chars.length
  let pwd = ''

  for (let i = 0; i < length; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
  }

  return pwd
}

export function getObjectDiffKeys (oldData = {}, newData = {}, opts = []) {
  const diff = objectDiff.diff(oldData, newData)

  return getDiffKeysByChange(diff, opts)
}

function isChangedObject (obj) {
  return isObject(obj) && isString(obj.changed)
}

export function getDiffKeysByChange (change = {}, opts = [], valueKey = '', keys = []) {
  if (isChangedObject(change)) {
    const { changed, value } = change

    if (opts.some((v) => changed.includes(v))) {
      if (valueKey) {
        keys.push(valueKey)
      }

      if (isObject(value)) {
        for (const key in value) {
          if (value.hasOwnProperty(key)) {
            const changeItem = value[key]

            getDiffKeysByChange(changeItem, opts, key, keys)
          }
        }
      }
    }
  }

  return keys.filter((v) => isNaN(v))
}

export function normalizeDynamicData (obj = {}, data = {}, method) {
  obj = obj || {}

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const item = obj[key]

      if (isDynamicVariableString(item)) {
        obj[key] = getDynamicVariableValue(item, data)
      } else if (isDynamicApiString(item)) {
        obj[key] = getDynamicApi(item, method)
      } else if (isObject(item) || Array.isArray(item)) {
        obj[key] = normalizeDynamicData(item, data, method)
      }
    }
  }

  return obj
}

export function isOnline () {
  return navigator.onLine
}
